import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'app-icon-button-cell-renderer',
  imports: [MatIconModule, MatButtonModule, MatTooltipModule],
  templateUrl: './icon-button-cell-renderer.html',
  styleUrl: './icon-button-cell-renderer.css',
})
export class IconButtonCellRenderer {
  params!: any;

  agInit(params: ICellRendererParams): void {
    this.refresh(params);
  }

  refresh(params: ICellRendererParams): boolean {
    this.params = params;
    return true;
  }

  onClick() {
    if (this.params.onClick) {
      this.params.onClick(this.params.data, this.params.node.rowIndex);
    }
  }
}
